<template>
  <div>
    <div class="background" >
      <container></container>
    </div>
  </div>
  
</template>

<script>

import container from './Indexcontainer'
export default {
  components:{
    container
  },
  data(){
    return{
      widthMax: window.innerWidth,
    }
  }
};
</script> 
<style scoped>
html{
  scroll-behavior: smooth;
}
.background{
    background: url('../assets/Home.png') no-repeat top center ;
    background-color: #1B1C65;
}

@media screen and (min-width: 100px) and (max-width: 767px) {
  .background{
    background: url('../assets/Home.png') no-repeat top left ;
    background-color: #1B1C65;
  }
}



</style>